import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Loading from '../../Components/Loading';
import { validateSession } from '../../API/APICalls';
import UserExportForm from '../../Components/Mailbox/UserExportForm';
import SnackbarShow from '../../Components/SnackbarShow';

const MailboxExportPage = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [domainIds, setDomainIds] = useState({});
    const [snackbarMessage, setSnackbarMessage] = useState({ open: false, message: '', severity: '' });



    const getDomainInfo = async (id) => {
        try {
            setLoading(true);
            const response = await validateSession(id);
            if (response.status === 200) {
                if (!response?.data?.domain_ids) {
                    setSnackbarMessage({ open: true, message: 'There is no domain ids data to export.', severity: 'error' });
                }
                setDomainIds(response.data.domain_ids);
            }
        } catch (error) {
            console.error(error);
            setSnackbarMessage({ open: true, message: `Something went wrong. Please try again later.`, severity: 'error' });
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getDomainInfo(id);
    }, [id]);

    if (loading) {
        return <Loading />
    }
    let snackbarMessageComp = (snackbarMessage.open) ? (<SnackbarShow data={snackbarMessage} setSnackbarMessage={setSnackbarMessage} />) : null;
    let exportComp = (domainIds === undefined || domainIds === null || Object.keys(domainIds).length === 0) ? (
        <h1>Domain details not present.</h1>
    ) : (
        <UserExportForm id={id} domainIds={domainIds} />
    );
    return (
        <>
            {snackbarMessageComp}
            {exportComp}
        </>
    );
};

export default MailboxExportPage;